<template>
  <div class="testPage" id="testPage" @click="showTip = false">
    <audio ref="audio" controls :src="currentProblem[sound + 'fy']" style="width: 0;height: 0;position: absolute;top: 0;">您的浏览器不支持 audio 标签。</audio>
    <studyHeader @back="back" />
    <div class="studyBox">
      <div class="main studyMain" v-if="content !== 'test'">
        <!-- 收藏 -->
        <!-- <div class="squirrel">
          <img src="../../../assets/images/student/squirrel.png" alt="">
        </div> -->
        <!-- 头部 -->
        <div class="unitsTitle">
          <img src="../../../assets/images/student/unitsTitle.png" alt="">
          <div class="text">开始测试</div>
        </div>
        <div class="progress">
          <el-progress :text-inside="true" :stroke-width="16" :percentage="submitData.problem ? ((currentIndex + 1) / submitData.problem.length * 100) : 0"></el-progress>
          <div class="text">{{ submitData.problem ? (currentIndex + 1 + '/' + submitData.problem.length) : 0 }}</div>
        </div>
        <!-- 英选汉 -->
        <div class="test1 cnAnswer" v-if="content == 'test1'">
          <div class="header">
            <div class="title">请选择正确的词义</div>
            <p class="time"> 剩余 <span>{{ time }}</span> 秒 </p>
          </div>
          <div class="wordaudio">
            <div class="word"> {{ currentProblem.nr }}
              <div class="img" @click="play">
                <img src="../../../assets/images/student/horn.png" alt="">
              </div>
            </div>
          </div>
          <div class="options">
            <div class="option" v-for="(item, index) in currentProblem.options" :key="item">
              <div class="answer" :class="answerSize[index]" :style="ansYes === item ? 'background: #8BDF1F;color: #fff;' : (ansNo === item ? 'background: #FF4545;color: #fff;' : '')" @click="doTest('1', item,$event)">
                {{ item }}
                <!-- 正确 -->
                <div class="icon" v-if="ansYes === item">
                  <img src="../../../assets/images/student/right.png" alt="">
                </div>
                <!-- 错误 -->
                <div class="icon" v-if="ansNo === item">
                  <img src="../../../assets/images/student/Wrong.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 拼词 -->
        <div class="test2" v-if="content == 'test2'">
          <!-- 头 -->
          <div class="header">
            <div class="title">看义拼词</div>
            <p class="time"> 剩余 <span>{{ time }}</span> 秒 </p>
          </div>
          <!-- 词义 -->
          <div class="mean">
            <span :title="currentProblem.cy" @click.stop="showAll(currentProblem.cy)">{{ currentProblem.cy }}</span>
          </div>
          <div class="options2">
            <div class="center">
              <div v-for="data in optionSelected" :key="data.txt" class="option2">{{ data.txt }}</div>
              <div class="del" @click="delAll" :style="optionSelected.length > 0 ? 'display:block;' : 'display:none;'"><i class="el-icon-circle-close"></i></div>
            </div>
          </div>
          <hr class="hr">
          <div class="answers2">
            <div class="answer2" :class="{ selected: optionSelected.map((ele) => {return ele.index }).indexOf(index) !== -1 }" v-for="(data, index) in currentProblem.options" :key="data" @click="selected(data, index)">
              {{ data }}
            </div>
          </div>
          <div class="btns" @click="submit($event)">
            <img src="../../../assets/images/student/cooked.png" alt="">
            <span class="text">提交</span>
          </div>
        </div>
        <!-- 汉译英 -->
        <div class="test1" v-if="content == 'test3'">
          <div class="header">
            <div class="title">请选择正确的单词</div>
            <p class="time"> 剩余 <span>{{ time }}</span> 秒 </p>
          </div>
          <div class="wordaudio">
            <!-- 词义 -->
            <div class="word wordhidden" :title="currentProblem.cy" @click.stop="showAll(currentProblem.cy)"> {{ currentProblem.cy }}
            </div>
          </div>
          <div class="options">
            <div class="option" v-for="(item, index) in currentProblem.options" :key="item">
              <div class="answer" :class="answerSize[index]" :style="ansYes === item ? 'background: #8BDF1F;color: #fff;' : (ansNo === item ? 'background: #FF4545;color: #fff;' : '')" @click="doTest('3', item, $event)">
                {{ item }}
                <!-- 正确 -->
                <div class="icon" v-if="ansYes === item">
                  <img src="../../../assets/images/student/right.png" alt="">
                </div>
                <!-- 错误 -->
                <div class="icon" v-if="ansNo === item">
                  <img src="../../../assets/images/student/Wrong.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 音选英 -->
        <div class="test4" v-if="content == 'test4'">
          <div class="header">
            <div class="title">请选择正确的单词</div>
            <p class="time"> 剩余 <span>{{ time }}</span> 秒 </p>
          </div>
          <div class="wordaudio">
            <div class="img">
              <img src="../../../assets/images/student/horn.png" alt="" @click="play">
            </div>
          </div>
          <div class="options">
            <div class="option" v-for="(item, index) in currentProblem.options" :key="item">
              <div class="answer" :class="answerSize[index]" :style="ansYes === item ? 'background: #8BDF1F;color: #fff;' : (ansNo === item ? 'background: #FF4545;color: #fff;' : '')" @click="doTest('4', item, $event)">
                {{ item }}
                <!-- 正确 -->
                <div class="icon" v-if="ansYes === item">
                  <img src="../../../assets/images/student/right.png" alt="">
                </div>
                <!-- 错误 -->
                <div class="icon" v-if="ansNo === item">
                  <img src="../../../assets/images/student/Wrong.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 开始测试 -->
      <div class="test" v-if="content == 'test'">
        <div class="congratulations">
          <div class="image">
            <img src="../../../assets/images/student/testcomplete.png" alt="">
            <!-- 分数展示 -->
            <em class="span"> {{ submitData.fs + '分' }} </em>
            <em class="text">
              本单元测试已完成!
            </em>
          </div>
        </div>
        <!-- 测试按钮 -->
        <div class="practice">
          <!-- <div class="left">
            <img src="../../../assets/images/student/practice.png" alt="">
            <span class="ltext">再次学习</span>
          </div> -->
          <div class="right" @click="toUnits">
            <img src="../../../assets/images/student/rightbtn.png" alt="">
            <span class="rtext">完成</span>
          </div>
        </div>
      </div>
      <div class="test" v-if="content == 'submitError'">
        <div class="congratulations">
          <div class="image">
            <img src="../../../assets/images/student/testcomplete.png" alt="">
            <em class="text">
              本单元已完成，结果暂未提交成功
            </em>
          </div>
        </div>
        <div class="practice">
          <div class="left" @click="back">
            <img src="../../../assets/images/student/practice.png" alt="">
            <span class="ltext">返回</span>
          </div>
          <div class="right" @click="retryPendingSubmit(false)">
            <img src="../../../assets/images/student/rightbtn.png" alt="">
            <span class="rtext">{{ retrying ? '提交中...' : '重新提交' }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogMsg" class="dialogMsg">
      <div class="dio">
        <img src="../../../assets/images/student/no1.png" v-if="dioAnswer == 'no1'" alt="">
        <img src="../../../assets/images/student/yes1.png" v-if="dioAnswer == 'yes1'" alt="">
        <div class="title" v-if="dioAnswer === 'no1'">正确答案</div>
        <div class="dioWord">{{ currentProblem.nr }}</div>
      </div>
    </el-dialog>
    <!-- <div class="showall" id="showall" @click.stop="showTip = true" v-show="showTip"></div> -->
  </div>
</template>
<script>
import { submitWords, getPmzt, getWords, saveMyBreakpoint, getMyBreakpoint, saveWordFinishSnapshot, getRecoverableWordFinishSnapshot, abandonWordFinishSnapshot } from '@/api/student'
export default {
  components:{
    studyHeader:(resolve) => {
      require(["@/components/student/studyHeader"], resolve)
    }
  },
  data(){
    return {
      content: '', // test完成 // test1看义选英 // test3看义选英 // test4听音辨义 // test2第二轮测试
      sound: '', // 发音
      submitData: {}, // 学习阶段产生的数据汇总
      wordList: [], // 单词列表,
      currentProblem: {}, // 当前题目
      currentIndex: 0, // 当前题目位置
      time: 20, // 倒计时
      timer: null, // 计时器
      ansYes: '', // 正确答案展示
      ansNo: '', // 错误答案展示
      clickStop: false, // 防高频点击
      optionSelected: [], // 看义拼词答案
      optionAns: [], // 看义拼词选项
      dialogMsg: false,
      dioAnswer: '', // 对的穿yes1  错的传no1
      source: '', // 来源
      backPath: '', // 返回上一页的地址
      showTip: false, // 控制showAll显示隐藏--文字超出时点击显示
      answerSize: [], // 选项缩放类，渲染后按实际是否溢出测量
      key: 0,
      pendingSubmitKey: '',
      retrying: false
    }
  },
  created() {
    this.key = Math.random()
    sessionStorage.setItem('key', this.key)
    this.$Bus.$on('whether', (val) => {
      if (val) {
        clearInterval(this.timer)
        this.timer = null
      } else {
        this.timeStart(this.time)
      }
    })
    this.source = this.$route.query.source
    this.sound = localStorage.getItem('sound_' + this.$store.state.userInfo.realname)
    if (this.source === 'studyway') {
      this.backPath = '/afterWordcontent?type=' + this.$route.query.type + '&bbid=' + this.$route.query.bbid + '&zid=' + this.$route.query.zid + '&zmc=' + this.$route.query.zmc + '&dyid=' + this.$route.query.dyid + '&source=' + this.$route.query.source + '&lxid=' + this.$route.query.lxid
      this.pendingSubmitKey = this.getPendingSubmitKey()
      let pendingSubmit = this.getPendingSubmit()
      if (pendingSubmit) {
        this.submitData = pendingSubmit
        this.content = 'submitError'
        this.retryPendingSubmit(true)
        return
      }
      this.checkRecoverableSnapshot().then(recovered => {
        if (recovered) {
          return
        }
        getMyBreakpoint({ dyid: ~~this.$route.query.dyid, cjid: this.getAfterJxInfo().jxid, xsid: this.$store.state.userInfo.yhid, cjlx: true, }).then(res => {
        if (res.success) {
          let notes = res.resultDesc === 'SUCCESS' ? '' : res.resultDesc
          if(notes){
            this.submitData = JSON.parse(res.resultDesc)
            this.submitData.startTime = new Date().getTime()
            if (this.submitData.problemIndex !== undefined) {
              this.wordList = JSON.parse(sessionStorage.getItem('words'))
              this.currentIndex = this.submitData.problemIndex + 1 === this.submitData.problem.length ? this.submitData.problemIndex : (this.submitData.problemIndex + 1)
              this.currentProblem = this.submitData.problem[this.currentIndex]
              this.content = 'test' + this.currentProblem.type
              if(this.content != 'test3') {
                this.$nextTick(() => {
                  this.play()
                })
              }
              getPmzt({ bjid: JSON.parse(sessionStorage.getItem('afterJxInfo')).bjid }).then(e => {
                if (e.result) {
                  this.timeStart(20)
                }
              })
            } else {
              this.submitData.problem = []
              this.submitData.progress = 1
              this.submitData.Bingo = 0
              this.submitData.zwsl = 0
              //this.submitData.problemIndex = this.currentIndex
              // 制作考试题
              this.wordList = JSON.parse(sessionStorage.getItem('words'))
              this.makeProblom()
              this.currentProblem = this.submitData.problem[this.currentIndex]
              this.content = 'test' + this.currentProblem.type
              if(this.content != 'test3') {
                this.$nextTick(() => {
                  this.play()
                })
              }
              getPmzt({ bjid: JSON.parse(sessionStorage.getItem('afterJxInfo')).bjid }).then(e => {
                if (e.result) {
                  this.timeStart(20)
                }
              })
            }
          } else { // 测试完成，刷新，跳回units
            this.toUnits()
          }
        } else {
          this.$message.error(res.resultDesc)
        }
        }).catch(err => {
          this.$message.error({ message: '当前网络卡顿，请刷新后重试', duration: 0 })
        })
      })
    } else {
      this.backPath = '/afterWordcontent?source=' + this.source
      this.submitData.problem = []
      this.submitData.Bingo = 0
      this.wordList = JSON.parse(sessionStorage.getItem('words'))
      this.makeProblom()
      this.currentProblem = this.submitData.problem[this.currentIndex]
      this.content = 'test' + this.currentProblem.type
      if(this.content != 'test3') {
        this.$nextTick(() => {
          this.play()
        })
      }
      this.timeStart(20)
    }
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods:{
    // 词义题干超过一行换行时，改成居左显示（看义拼词 + 请选择正确的单词）
    checkStemWrap() {
      this.$nextTick(() => {
        const targets = [
          this.$el.querySelector('.test2 .mean span'),
          this.$el.querySelector('.word.wordhidden')
        ]
        targets.forEach(el => {
          if (!el) return
          const range = document.createRange()
          range.selectNodeContents(el)
          // 过滤掉纯空白产生的 0 宽行盒，按实际文字行数判断是否换行
          const lineCount = Array.from(range.getClientRects()).filter(rect => rect.width > 0).length
          el.classList.toggle('wrap', lineCount > 1)
        })
      })
    },
    // 渲染后测量选项文字，只有一行显示不下时才缩小字号
    calcAnswerSize() {
      this.$nextTick(() => {
        const answers = this.$el.querySelectorAll('.options .option .answer')
        if (!answers.length) return
        const sizes = []
        answers.forEach(el => {
          el.classList.remove('long', 'xlong')
          // 请选择正确的词义（英选汉）选项不缩小字号，超长换行显示，与学习环节保持一致
          if (el.closest('.cnAnswer')) {
            sizes.push('')
            return
          }
          // 临时强制单行，比较文字宽度与选项框宽度判断是否溢出
          el.style.setProperty('white-space', 'nowrap', 'important')
          let size = ''
          if (el.scrollWidth > el.clientWidth) {
            el.classList.add('long')
            size = 'long'
            if (el.scrollWidth > el.clientWidth) {
              el.classList.add('xlong')
              size = 'xlong'
            }
          }
          el.style.removeProperty('white-space')
          sizes.push(size)
        })
        this.answerSize = sizes
      })
    },
    getAfterJxInfo() {
      try {
        return JSON.parse(sessionStorage.getItem('afterJxInfo') || '{}')
      } catch (e) {
        return {}
      }
    },
    getPendingSubmitKey() {
      let jxInfo = this.getAfterJxInfo()
      return 'words_after_pending_submit_' + this.$store.state.userInfo.yhid + '_' + jxInfo.jxid + '_' + this.$route.query.dyid
    },
    createClientSubmitId() {
      return 'words_after_' + this.$store.state.userInfo.yhid + '_' + new Date().getTime() + '_' + Math.random().toString(16).slice(2)
    },
    getPendingSubmit() {
      let pendingSubmit = localStorage.getItem(this.pendingSubmitKey)
      if (!pendingSubmit) {
        return null
      }
      try {
        return JSON.parse(pendingSubmit)
      } catch (e) {
        this.clearPendingSubmit()
        return null
      }
    },
    savePendingSubmit(data) {
      localStorage.setItem(this.pendingSubmitKey, JSON.stringify(data))
    },
    clearPendingSubmit() {
      localStorage.removeItem(this.pendingSubmitKey)
    },
    checkRecoverableSnapshot() {
      let jxInfo = this.getAfterJxInfo()
      return getRecoverableWordFinishSnapshot({
        dyid: ~~this.$route.query.dyid,
        jxid: jxInfo.jxid,
        xsid: this.$store.state.userInfo.yhid
      }).then(res => {
        if (res.success && res.result && res.result.submitPayload) {
          return this.$confirm('检测到你上次已完成本单元测试，但结果还没有提交成功。是否继续提交上次结果？', '提示', {
            confirmButtonText: '继续提交',
            cancelButtonText: '重新测试',
            type: 'warning'
          }).then(() => {
            try {
              let submitPayload = JSON.parse(res.result.submitPayload)
              this.submitData = submitPayload
              this.savePendingSubmit(submitPayload)
              this.content = 'submitError'
              this.retryPendingSubmit(true)
              return true
            } catch (e) {
              abandonWordFinishSnapshot({clientSubmitId: res.result.clientSubmitId})
              return false
            }
          }).catch(() => {
            abandonWordFinishSnapshot({clientSubmitId: res.result.clientSubmitId})
            this.startNewTest()
            return true
          })
        }
        return false
      }).catch(() => false)
    },
    startNewTest() {
      this.submitData.problem = []
      this.submitData.progress = 1
      this.submitData.Bingo = 0
      this.submitData.zwsl = 0
      // 恢复的快照 payload 在提交前已删除 startTime，重新测试必须重置，否则学习时长会算成 NaN
      this.submitData.startTime = new Date().getTime()
      this.wordList = JSON.parse(sessionStorage.getItem('words'))
      this.makeProblom()
      this.currentIndex = 0
      this.currentProblem = this.submitData.problem[this.currentIndex]
      this.content = 'test' + this.currentProblem.type
      if(this.content != 'test3') {
        this.$nextTick(() => {
          this.play()
        })
      }
      getPmzt({ bjid: this.getAfterJxInfo().bjid }).then(e => {
        if (e.result) {
          this.timeStart(20)
        }
      })
    },
    isSubmitProcessing(res, error) {
      let status = error && error.response && error.response.status
      let resultCode = error && error.response && error.response.data && error.response.data.resultCode
      return status === 409 || resultCode === 409 || (res && res.resultCode === 409)
    },
    retryPendingSubmit(silent, retryCount) {
      if (this.retrying) {
        return
      }
      retryCount = retryCount || 0
      let pendingSubmit = this.getPendingSubmit() || this.submitData
      if (!pendingSubmit) {
        return
      }
      // 兜底：历史遗留的待提交数据可能缺 zmc，提交前从路由补齐并回存
      if (!pendingSubmit.zmc && this.$route.query.zmc) {
        pendingSubmit.zmc = this.$route.query.zmc
        this.savePendingSubmit(pendingSubmit)
      }
      this.retrying = true
      submitWords(pendingSubmit).then(res => {
        if (res.success) {
          this.applySubmitResult(res)
          this.clearPendingSubmit()
          this.content = 'test'
        } else if (this.isSubmitProcessing(res) && silent && retryCount < 3) {
          setTimeout(() => {
            this.retrying = false
            this.retryPendingSubmit(true, retryCount + 1)
          }, 1500)
          return
        } else if (this.isSubmitProcessing(res)) {
          this.content = 'submitError'
          this.$message.warning('提交处理中，请稍后再试')
        } else if (!silent) {
          this.content = 'submitError'
          this.$message.warning('考试结果提交失败,请稍后重试')
        }
        this.retrying = false
      }).catch(error => {
        this.content = 'submitError'
        if (this.isSubmitProcessing(null, error) && silent && retryCount < 3) {
          setTimeout(() => {
            this.retrying = false
            this.retryPendingSubmit(true, retryCount + 1)
          }, 1500)
          return
        }
        if (this.isSubmitProcessing(null, error)) {
          this.$message.warning('提交处理中，请稍后再试')
        } else if (!silent) {
          this.$message.warning('考试结果提交失败,请稍后重试')
        }
        this.retrying = false
      })
    },
    applySubmitResult(res) {
      //后端 WordsSubmitResp 已直接返回 fs/xj/yzws，无需依赖本地 afterJxInfo.dcsl 换算
      let result = (res.result && typeof res.result === 'object') ? res.result : {}
      this.submitData.fs = result.fs != null ? result.fs : 0
      this.submitData.xj = result.xj != null ? result.xj : 0
      this.submitData.yzws = result.yzws != null ? result.yzws : 0
      //提交结果处理日志：raw 为后端原始返回摘要，applied 为写入 submitData 的最终值
      console.log('[wordsSubmit] applySubmitResult', JSON.stringify({
        dyid: this.$route && this.$route.query ? this.$route.query.dyid : undefined,
        success: res.success,
        resultCode: res.resultCode,
        resultType: res.result === null ? 'null' : typeof res.result,
        clientSubmitId: result.clientSubmitId,
        repeated: result.repeated,
        raw: { fs: result.fs, xj: result.xj, yzws: result.yzws, dcsl: result.dcsl },
        applied: { fs: this.submitData.fs, xj: this.submitData.xj, yzws: this.submitData.yzws }
      }))
      if (!(res.result && typeof res.result === 'object')) {
        //非对象 result 属于异常形状（后端契约变化），已兜底为 0，需结合后端日志排查
        console.warn('[wordsSubmit] applySubmitResult 收到非对象 result，已兜底为 0，result=', res.result)
      }
    },
    // 题目超出时，点击展示全部
    showAll(val) {
      // var oDom = document.querySelector('.showall')
      // oDom.innerHTML = val
      this.showTip = !this.showTip
    },
    back() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.$router.replace({ path: this.backPath })
    },
    // 生成小虹心
    heartsFun(e){
      // 获取点击坐标
      let x = e.pageX;
      let y = e.pageY;
      for(let i = 0 ; i < 1 ; i++){
        let oDiv = document.createElement('div')
        oDiv.innerHTML = '❤'
        oDiv.className = 'animate__animated animate__fadeInUp'
        setTimeout(() => {
          oDiv.className = 'animate__animated animate__fadeOut'
        }, 1000)
        oDiv.style.cssText = `position:absolute;font-size:3rem;color:red;left:${x - 15}px;top:${y - 120}px;`
        document.body.appendChild(oDiv)
        setTimeout(() => {
          if(document.querySelector('.animate__fadeOut')){
            document.body.removeChild(oDiv)
          }
        },1500)
      }
    },
    // 随机数
    MathRandom(max,min){
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 制作考试题
    makeProblom() {
      this.wordList.forEach(ele => {
        let arr1 = ele.yyh.split('##').splice(0,3)
        arr1.push(ele.cy)
        arr1.sort(() => Math.random() - 0.5)
        let arr3 = ele.hyy.split('##').splice(0,3)
        arr3.push(ele.nr)
        arr3.sort(() => Math.random() - 0.5)
        let arr4 = ele.tyxy.split('##').splice(0,3)
        arr4.push(ele.nr)
        arr4.sort(() => Math.random() - 0.5)
        let test1 = {
          type: '1',
          nr: ele.nr,
          cy: ele.cy,
          dcid: ele.id,
          ygfy: ele.ygfy,
          mgfy: ele.mgfy,
          options: arr1
        }
        let test3 = {
          type: '3',
          nr: ele.nr,
          cy: ele.cy,
          dcid: ele.id,
          ygfy: ele.ygfy,
          mgfy: ele.mgfy,
          options: arr3
        }
        let test4 = {
          type: '4',
          nr: ele.nr,
          cy: ele.cy,
          dcid: ele.id,
          ygfy: ele.ygfy,
          mgfy: ele.mgfy,
          options: arr4
        }
        this.submitData.problem.push(test1, test3, test4)
        if (!ele.lx) {
          let arr2 = ele.dccf + ',' + ele.grcfx
          let test2 = {
            type: '2',
            nr: ele.nr,
            cy: ele.cy,
            dcid: ele.id,
            ygfy: ele.ygfy,
            mgfy: ele.mgfy,
            options: arr2.split(',').splice(0,8).sort(() => Math.random() - 0.5)
          }
          this.submitData.problem.push(test2)
        }
      })
      this.submitData.problem.sort(() => Math.random() - 0.5)
    },
    // 完成，返回
    toUnits() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (this.source === 'studyway') {
        this.$router.replace({ path: '/afterUnits?type=' + this.$route.query.type + '&bbid=' + this.$route.query.bbid + '&zid=' + this.$route.query.zid + '&zmc=' + this.$route.query.zmc + '&lxid=' + this.$route.query.lxid  })
      } else if (this.source === 'wrong') {
        this.$router.replace({ path: '/wordbook/question' })
      } else if (this.source === 'collect') {
        this.$router.replace({ path: '/wordbook/collection' })
      }
    },
    // 发音
    play() {
      this.$refs.audio.play()
    },
    // 计时开始
    timeStart(time) {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.time = time
      this.timer = setInterval(() => {
        this.time--
        if (this.time === 0) {
          if ((this.submitData.dyid + '' == this.$route.query.dyid) && (this.key == sessionStorage.getItem('key'))) {
            this.optionSelected = []
            clearInterval(this.timer)
            this.timer = null
            if (this.source === 'studyway') {
              if (this.currentProblem.type === '1') {
                this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } }).yyh = 0
              } else if (this.currentProblem.type === '3') {
                this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } }).hyy = 0
              } else if (this.currentProblem.type === '4'){
                this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } }).tyxy = 0
              } else {
                this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } }).kypc = 0
              }
            }
            if (this.source === 'studyway') {
              let obj = this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } })
              if (obj && !obj.lx && (Object.keys(obj).length === 8)) {
                obj.sfzw = Number(obj.kypc && obj.tyxy && obj.yyh && obj.hyy)
                this.submitData.zwsl += obj.sfzw
                if (obj.sfzw && obj.sfsx) {
                  obj.dczt = 2
                } else if (obj.sfzw && !obj.sfsx) {
                  obj.dczt = 1
                } else if (obj.sfsx && (obj.kypc || obj.tyxy || obj.yyh || obj.hyy)) {
                  obj.dczt = 1
                } else {
                  obj.dczt = 0
                }
              } else if (obj && obj.lx && (Object.keys(obj).length === 7)) {
                obj.kypc = 1
                obj.sfzw = Number(obj.kypc && obj.tyxy && obj.yyh && obj.hyy)
                this.submitData.zwsl += obj.sfzw
                if (obj.sfzw && obj.sfsx) {
                  obj.dczt = 2
                } else if (obj.sfzw && !obj.sfsx) {
                  obj.dczt = 1
                } else if (obj.sfsx && (obj.kypc || obj.tyxy || obj.yyh || obj.hyy)) {
                  obj.dczt = 1
                } else {
                  obj.dczt = 0
                }
              }
              this.submitData.problemIndex = this.currentIndex
              this.submitData.xxsc = this.submitData.xxsc + parseInt((new Date().getTime() - this.submitData.startTime) / 1000)
              this.submitData.startTime = new Date().getTime()
              if (this.currentIndex + 1 !== this.submitData.problem.length) {
                // cjlx 任务false集训true
                saveMyBreakpoint({ cjid: this.getAfterJxInfo().jxid, cjlx: true, ddxx: JSON.stringify(this.submitData), dyid: Number(this.$route.query.dyid), xsid: this.$store.state.userInfo.yhid }).then(res => {
                  this.nextItem()
                }).catch(error => {
                  this.$message.error({ message: '当前网络卡顿，请刷新后重试', duration: 0 })
                })
              } else {
                this.nextItem()
              }
            } else {
              this.nextItem()
            }
          } else {
            clearInterval(this.timer)
            this.timer = null
          }
        }
      }, 1000)
    },
    // 下一题
    nextItem() {
      if (this.key != sessionStorage.getItem('key')) {
        return false
      }
      if (this.currentIndex + 1 === this.submitData.problem.length) {
        if (this.source === 'studyway') {
          let submitPayload = JSON.parse(JSON.stringify(this.submitData))
          delete submitPayload.problem
          delete submitPayload.Bingo
          delete submitPayload.startTime
          delete submitPayload.progress
          delete submitPayload.problemIndex
          delete submitPayload.zwsl
          let jxInfo = this.getAfterJxInfo()
          submitPayload.xzid = jxInfo.xzid
          submitPayload.xzmc = jxInfo.xzmc
          // 兜底：直接链接进入或旧断点数据可能缺 zmc，提交前从路由补齐
          if (!submitPayload.zmc && this.$route.query.zmc) {
            submitPayload.zmc = this.$route.query.zmc
          }
          if (!submitPayload.clientSubmitId) {
            submitPayload.clientSubmitId = this.createClientSubmitId()
          }
          this.submitData.list.forEach(ele => {
            if (ele.dczt === undefined) {
              ele.hyy = 1
              ele.kypc = 1
              ele.tyxy = 1
              ele.yyh = 1
              ele.dczt = 2
              ele.sfzw = 1
            }
          })
          submitPayload.list = this.submitData.list
          this.submitData = submitPayload
          this.savePendingSubmit(submitPayload)
          saveWordFinishSnapshot(submitPayload).then(res => {
            if (res.success) {
              this.retryPendingSubmit(false)
            } else {
              this.content = 'submitError'
              this.$message.warning('考试结果提交失败,请稍后重试')
            }
          }).catch(error => {
            this.content = 'submitError'
            this.$message.warning(this.isSubmitProcessing(null, error) ? '提交处理中，请稍后再试' : '考试结果提交失败,请稍后重试')
          })
        } else {
          this.submitData.fs = parseInt(this.submitData.Bingo / this.submitData.problem.length * 100)
          this.content = 'test'
        }
      } else {
        this.currentIndex++
        this.currentProblem = this.submitData.problem[this.currentIndex]
        this.content = 'test' + this.currentProblem.type
        this.timeStart(20)
      }
    },
    // 选择题提交
    doTest(type, item,e) {
      if (this.clickStop) {
        return ''
      }
      clearInterval(this.timer)
      this.timer = null
      this.clickStop = true
      this.ansYes = type === '1' ? this.currentProblem.cy : this.currentProblem.nr
      if (item === this.ansYes) {
        this.submitData.Bingo++
        this.heartsFun(e)
      } else {
        this.ansNo = item
      }
      if (this.source === 'studyway') {
        if (type === '1') {
          this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } }).yyh = Number(item === this.ansYes)
        } else if (type === '3') {
          this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } }).hyy = Number(item === this.ansYes)
        } else {
          this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } }).tyxy = Number(item === this.ansYes)
        }
      }
      if (this.source === 'studyway') {
        let obj = this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } })
        if (obj && !obj.lx && (Object.keys(obj).length === 8)) {
          obj.sfzw = Number(obj.kypc && obj.tyxy && obj.yyh && obj.hyy)
          this.submitData.zwsl += obj.sfzw
          if (obj.sfzw && obj.sfsx) {
            obj.dczt = 2
          } else if (obj.sfzw && !obj.sfsx) {
            obj.dczt = 1
          } else if (obj.sfsx && (obj.kypc || obj.tyxy || obj.yyh || obj.hyy)) {
            obj.dczt = 1
          } else {
            obj.dczt = 0
          }
        } else if (obj && obj.lx && (Object.keys(obj).length === 7)) {
          obj.kypc = 1
          obj.sfzw = Number(obj.kypc && obj.tyxy && obj.yyh && obj.hyy)
          this.submitData.zwsl += obj.sfzw
          if (obj.sfzw && obj.sfsx) {
            obj.dczt = 2
          } else if (obj.sfzw && !obj.sfsx) {
            obj.dczt = 1
          } else if (obj.sfsx && (obj.kypc || obj.tyxy || obj.yyh || obj.hyy)) {
            obj.dczt = 1
          } else {
            obj.dczt = 0
          }
        }
        this.submitData.problemIndex = this.currentIndex
        this.submitData.xxsc = this.submitData.xxsc + parseInt((new Date().getTime() - this.submitData.startTime) / 1000)
        this.submitData.startTime = new Date().getTime()
        if (this.currentIndex + 1 !== this.submitData.problem.length) {
          // cjlx 任务false集训true
          saveMyBreakpoint({ cjid: this.getAfterJxInfo().jxid, cjlx: true, ddxx: JSON.stringify(this.submitData), dyid: Number(this.$route.query.dyid), xsid: this.$store.state.userInfo.yhid}).then(res => {
            setTimeout(() => {
              this.ansNo = ''
              this.ansYes = ''
              this.nextItem()
              this.clickStop = false
            }, 500)
          }).catch(error => {
            this.$message.error({ message: '当前网络卡顿，请刷新后重试', duration: 0 })
          })
        } else {
          setTimeout(() => {
            this.ansNo = ''
            this.ansYes = ''
            this.nextItem()
            this.clickStop = false
          }, 1000)
        }
      } else {
        setTimeout(() => {
          this.ansNo = ''
          this.ansYes = ''
          this.nextItem()
          this.clickStop = false
        }, 1000)
      }
    },
    // 拼词题点击选项
    selected(data, index) {
      if (this.optionSelected.map((ele) => {return ele.index }).indexOf(index) === -1) {
        this.optionSelected.push({ txt: data, index: index })
      } else {
        this.optionSelected.splice(this.optionSelected.map((ele) => {return ele.index }).indexOf(index), 1)
      }
    },
    // 拼词题删除选项
    delAll() {
      this.optionSelected = []
    },
    // 拼词题提交答案
    submit(e) {
      if (this.clickStop) {
        return ''
      }
      this.clickStop = true
      if (this.optionSelected.length === 0) {
        this.$message.warning('请拼写成正确的单词')
        this.clickStop = false
      } else {
        clearInterval(this.timer)
        this.timer = null
        let word = ''
        this.optionSelected.forEach(ele => {
          word += ele.txt
        })
        if (word.toLowerCase() === this.currentProblem.nr.toLowerCase()) {
          this.submitData.Bingo++
          this.heartsFun(e)
          if (this.source === 'studyway') {
            this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } }).kypc = Number(word.toLowerCase() === this.currentProblem.nr.toLowerCase())
          }
          this.dioAnswer = 'yes1'
          if (this.source === 'studyway') {
            let obj = this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } })
            if (obj && !obj.lx && (Object.keys(obj).length === 8)) {
              obj.sfzw = Number(obj.kypc && obj.tyxy && obj.yyh && obj.hyy)
              this.submitData.zwsl += obj.sfzw
              if (obj.sfzw && obj.sfsx) {
                obj.dczt = 2
              } else if (obj.sfzw && !obj.sfsx) {
                obj.dczt = 1
              } else if (obj.sfsx && (obj.kypc || obj.tyxy || obj.yyh || obj.hyy)) {
                obj.dczt = 1
              } else {
                obj.dczt = 0
              }
            } else if (obj && obj.lx && (Object.keys(obj).length === 7)) {
              obj.kypc = 1
              obj.sfzw = Number(obj.kypc && obj.tyxy && obj.yyh && obj.hyy)
              this.submitData.zwsl += obj.sfzw
              if (obj.sfzw && obj.sfsx) {
                obj.dczt = 2
              } else if (obj.sfzw && !obj.sfsx) {
                obj.dczt = 1
              } else if (obj.sfsx && (obj.kypc || obj.tyxy || obj.yyh || obj.hyy)) {
                obj.dczt = 1
              } else {
                obj.dczt = 0
              }
            }
            this.submitData.problemIndex = this.currentIndex
            this.submitData.xxsc = this.submitData.xxsc + parseInt((new Date().getTime() - this.submitData.startTime) / 1000)
            this.submitData.startTime = new Date().getTime()
            if (this.currentIndex + 1 !== this.submitData.problem.length) {
              // cjlx 任务false集训true
              saveMyBreakpoint({ cjid: this.getAfterJxInfo().jxid, cjlx: true, ddxx: JSON.stringify(this.submitData), dyid: Number(this.$route.query.dyid), xsid: this.$store.state.userInfo.yhid }).then(res => {
                this.$nextTick(() => {
                  this.dialogMsg = true
                  setTimeout(() => {
                    this.optionSelected = []
                    this.dioAnswer = ''
                    this.dialogMsg = false
                    this.clickStop = false
                    this.nextItem()
                  }, 500)
                })
              }).catch(error => {
                this.$message.error({ message: '当前网络卡顿，请刷新后重试', duration: 0 })
              })
            } else {
              this.$nextTick(() => {
                this.dialogMsg = true
                setTimeout(() => {
                  this.optionSelected = []
                  this.dioAnswer = ''
                  this.dialogMsg = false
                  this.clickStop = false
                  this.nextItem()
                }, 1000)
              })
            }
          } else {
            this.$nextTick(() => {
              this.dialogMsg = true
              setTimeout(() => {
                this.optionSelected = []
                this.dioAnswer = ''
                this.dialogMsg = false
                this.clickStop = false
                this.nextItem()
              }, 1000)
            })
          }

        } else {
          if (this.source === 'studyway') {
            this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } }).kypc = Number(word === this.currentProblem.nr)
          }
          this.dioAnswer = 'no1'
          if (this.source === 'studyway') {
            let obj = this.submitData.list.find(ele => { if (ele.dcid === this.currentProblem.dcid) { return ele } })
            if (obj && !obj.lx && (Object.keys(obj).length === 8)) {
              obj.sfzw = Number(obj.kypc && obj.tyxy && obj.yyh && obj.hyy)
              this.submitData.zwsl += obj.sfzw
              if (obj.sfzw && obj.sfsx) {
                obj.dczt = 2
              } else if (obj.sfzw && !obj.sfsx) {
                obj.dczt = 1
              } else if (obj.sfsx && (obj.kypc || obj.tyxy || obj.yyh || obj.hyy)) {
                obj.dczt = 1
              } else {
                obj.dczt = 0
              }
            } else if (obj && obj.lx && (Object.keys(obj).length === 7)) {
              obj.kypc = 1
              obj.sfzw = Number(obj.kypc && obj.tyxy && obj.yyh && obj.hyy)
              this.submitData.zwsl += obj.sfzw
              if (obj.sfzw && obj.sfsx) {
                obj.dczt = 2
              } else if (obj.sfzw && !obj.sfsx) {
                obj.dczt = 1
              } else if (obj.sfsx && (obj.kypc || obj.tyxy || obj.yyh || obj.hyy)) {
                obj.dczt = 1
              } else {
                obj.dczt = 0
              }
            }
            this.submitData.problemIndex = this.currentIndex
            this.submitData.xxsc = this.submitData.xxsc + parseInt((new Date().getTime() - this.submitData.startTime) / 1000)
            this.submitData.startTime = new Date().getTime()
            if (this.currentIndex + 1 !== this.submitData.problem.length) {
              // cjlx 任务false集训true
              saveMyBreakpoint({ cjid: this.getAfterJxInfo().jxid, cjlx: true, ddxx: JSON.stringify(this.submitData), dyid: Number(this.$route.query.dyid), xsid: this.$store.state.userInfo.yhid }).then(res => {
                this.$nextTick(() => {
                  this.dialogMsg = true
                  setTimeout(() => {
                    this.optionSelected = []
                    this.dioAnswer = ''
                    this.dialogMsg = false
                    this.clickStop = false
                    this.nextItem()
                  }, 1500)
                })
              }).catch(error => {
                this.$message.error({ message: '当前网络卡顿，请刷新后重试', duration: 0 })
              })
            } else {
              this.$nextTick(() => {
                this.dialogMsg = true
                setTimeout(() => {
                  this.optionSelected = []
                  this.dioAnswer = ''
                  this.dialogMsg = false
                  this.clickStop = false
                  this.nextItem()
                }, 2000)
              })
            }
          } else {
            this.$nextTick(() => {
              this.dialogMsg = true
              setTimeout(() => {
                this.optionSelected = []
                this.dioAnswer = ''
                this.dialogMsg = false
                this.clickStop = false
                this.nextItem()
              }, 2000)
            })
          }
        }
      }
    }
  },
  watch: {
    currentIndex(newV,oldV) {
      if(this.content != 'test3'){
        this.$nextTick(() => {
          this.play()
        })
      }
      if (this.content == 'test2' || this.content == 'test3') {
        this.checkStemWrap()
      }
    },
    content(newV) {
      if (newV === 'test2' || newV === 'test3') {
        this.checkStemWrap()
      }
    },
    currentProblem() {
      //题目切换后测量选项宽度，填充 answerSize 缩放类
      this.calcAnswerSize()
    },
  }
}
</script>
<style lang="scss" scoped>
/* ========== 平板端适配样式 ========== */
@media screen and (min-width: 701px) and (max-width: 1366px) {
  .testPage {
    .main {
      background: none !important;
    }

    .progress {
      margin-top: -1.8vw !important;
      align-items: center !important;

      .text {
        font-size: 1.6vw !important;
        line-height: 1 !important;
        padding-left: 14px !important;
      }
    }

    .test1,
    .test4 {
      .wordaudio {
        .word {
          font-size: 2.2vw !important;

          .img {
            width: 2.8vw !important;
            height: 2.8vw !important;
            right: -3.6vw !important;
            top: 50% !important;
            transform: translateY(-50%) !important;
          }
        }
      }

      .options .option {
        margin-bottom: 3.5% !important;

        .answer {
          width: 70% !important;
          font-size: 2.2vw !important;
          padding: 2.2% 2vw !important;
          line-height: 2.4vw !important;

          &.long {
            font-size: 1.7vw !important;
          }

          &.xlong {
            font-size: 1.3vw !important;
          }
        }
      }

      .wordaudio .word.wordhidden {
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 2 !important;
        white-space: normal !important;
        font-size: 1.8vw !important;
        line-height: 1.3 !important;
      }
    }

    .cnAnswer {
      .wordaudio {
        margin-top: -2vw !important;

        .word {
          transform: translateX(-1.8vw) !important;
        }
      }

      .options .option {
        height: auto !important;
        margin-bottom: 2% !important;
      }

      .options .option .answer {
        width: 85% !important;
        padding: 1.6% 4% !important;
        text-align: left !important;
        line-height: 1.3 !important;
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: clip !important;
        word-break: break-word !important;

        .icon {
          display: none !important;
        }
      }
    }

    .test2 {
      .mean {
        font-size: 2.1vw !important;
        line-height: 1.3 !important;
      }

      .option2 {
        font-size: 2.9vw !important;
        line-height: 2.9vw !important;
      }

      .answers2 {
        width: 82% !important;
        display: flex !important;
        flex-wrap: wrap !important;
        justify-content: flex-start !important;
        align-content: flex-start !important;
        gap: 1.6vw 1vw !important;
      }

      .answers2 .answer2 {
        font-size: 2.7vw !important;
        width: auto !important;
        min-width: calc((100% - 3vw) / 4) !important;
        height: auto !important;
        min-height: 5vw !important;
        line-height: 1.2 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        float: none !important;
        margin: 0 !important;
        padding: 0.4vw 0.3vw !important;
        box-sizing: border-box !important;
        white-space: normal !important;
        word-break: break-word !important;
      }
    }
  }
}

/* ========== 电脑端：中文选项答案换行显示 ========== */
@media screen and (min-width: 1367px) {
  .testPage .progress {
    margin-top: -1.5vw !important;
  }

  .testPage .cnAnswer .options {
    overflow-y: auto !important;
  }

  .testPage .cnAnswer .options .option {
    height: auto !important;
    margin-bottom: 1.5% !important;

    .answer {
      width: 60% !important;
      padding: 1% 3% !important;
      line-height: 1.3 !important;
      text-align: left !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      word-break: break-word !important;

      .icon {
        display: none !important;
      }
    }
  }
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 700px) {
  .testPage {
    .main {
      background: rgba(255, 255, 255, 0.95) !important;
      border-radius: 20px !important;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
      backdrop-filter: blur(2px);
    }
    .studyMain {
      width: 85% !important;
      height: 70% !important;
      padding: 8vw 4vw !important;

      .unitsTitle {
        width: 70% !important;
        top: -8% !important;

        .text {
          font-size: 14px !important;
          padding-top: 6px !important;

        }
      }
    }

    .progress {
      width: 90% !important;
      padding-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      .text {
        font-size: 12px !important;
        text-align: right;
      }
    }

    .test1,
    .test3,
    .test4 {
      .header {
        .title {
          font-size: 16px !important;
        }

        .time {
          font-size: 12px !important;

          span {
            font-size: 14px !important;
          }
        }
      }

      .wordaudio {
        .word {
          font-size: 26px !important;
          max-width: 100% !important;
          display: inline-flex !important;
          align-items: center;
          justify-content: center;
          gap: 8px;
          -webkit-line-clamp: unset;
        }

        .word.wordhidden {
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          -webkit-line-clamp: 2 !important;
          white-space: normal !important;
          font-size: 20px !important;
          line-height: 1.3 !important;
        }

        .img {
          position: static !important;
          top: auto !important;
          right: auto !important;
          width: 30px !important;
          height: 30px !important;
          flex-shrink: 0;
        }
      }

      .options {
        .option {
          .answer {
            width: 85% !important;
            font-size: 20px !important;
            padding: 8px 14px !important;
            line-height: 20px !important;
            border: 2px solid #5990ff !important;

            &.long {
              font-size: 16px !important;
            }

            &.xlong {
              font-size: 13px !important;
            }

            .icon {
              width: 24px !important;
              height: 24px !important;
              right: -30px !important;
            }
          }
        }
      }
    }

    .cnAnswer {
      .options .option {
        height: auto !important;
        margin-bottom: 10px !important;
      }

      .options .option .answer {
        width: 85% !important;
        font-size: 16px !important;
        padding: 10px 14px !important;
        line-height: 1.4 !important;
        text-align: left !important;
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: clip !important;
        word-break: break-word !important;

        .icon {
          display: none !important;
        }
      }
    }

    .test2 {
      .header {
        .title {
          font-size: 16px !important;
        }

        .time {
          font-size: 12px !important;

          span {
            font-size: 14px !important;
          }
        }
      }

      .mean {
        font-size: 22px !important;
        height: auto !important;
        margin: 10px 0;
        padding: 0 10px;

        span {
          line-height: 1.3 !important;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-word;
        }
      }

      .options2 {
        margin: 10px 0;
        min-height: 50px;

        .center {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 8px;
          width: 100%;
          position: relative;
          padding-right: 30px;
          box-sizing: border-box;
        }

        .option2 {
          font-size: 14px !important;
          line-height: 4vw !important;
          padding: 6px 12px !important;
          float: none;
          margin: 0;
        }

        .del {
          font-size: 20px !important;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .hr {
        margin: 15px auto;
        width: 60%;
      }

      .answers2 {
        width: 100% !important;
        height: auto !important;
        max-height: 180px;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 8px;
        padding: 10px 5px;
        margin: 0 auto;

        .answer2 {
          font-size: 20px !important;
          height: 40px !important;
          line-height: 40px !important;
          width: auto !important;
          min-width: 70px;
          padding: 0 12px;
          margin: 0 !important;
          float: none;
          border: 2px solid #5990ff !important;
        }
      }

      .btns {
        position: relative;
        bottom: auto;
        width: 40% !important;
        margin: 20px auto 0;
        transform: none;
        left: auto;

        span {
          font-size: 14px !important;
        }
      }
    }

    .congratulations {
      width: 80% !important;
      height: auto !important;

      .image {
        .text {
          font-size: 12px !important;
          bottom: 15% !important;
          left: 0 !important;
        }

        .span {
          font-size: 28px !important;
          top: 58% !important;
          left: 50% !important;
          -webkit-text-stroke: 1px #FF4545 !important;
        }
      }
    }

    .practice {
      width: 120px !important;
      height: 40px !important;
      bottom: 8% !important;

      .right,
      .left {
        width: 120px !important;
        height: 40px !important;

        span {
          font-size: 14px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .testPage {
    .main {
      background: rgba(255, 255, 255, 0.96) !important;
      border-radius: 16px !important;
    }
    .studyMain {
      width: 94% !important;
      padding: 8vw 3vw !important;
    }
    .el-progress {
      width: 90%;
      margin: auto;
      padding-right: 10px;
    }
    .test1,
    .test3,
    .test4 {
      .options .option .answer {
        width: 90% !important;
        font-size: 21px !important;
        padding: 8px 12px !important;
        border: 2px solid #5990ff !important;

        &.long {
          font-size: 16px !important;
        }

        &.xlong {
          font-size: 13px !important;
        }
      }

      .wordaudio .word.wordhidden {
        font-size: 18px !important;
      }
    }

    .cnAnswer {
      .options .option .answer {
        width: 90% !important;
        font-size: 16px !important;
        padding: 8px 12px !important;
        text-align: left !important;
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: clip !important;
        word-break: break-word !important;
      }
    }

    .test2 {
      .answers2 .answer2 {
        font-size: 16px !important;
        height: 36px !important;
        line-height: 36px !important;
        min-width: 60px;
        padding: 0 10px;
        border: 2px solid #5990ff !important;
      }

      .options2 .option2 {
        font-size: 12px !important;
        padding: 4px 10px !important;
        line-height: 4vw !important;
      }

      .btns {
        width: 50% !important;
      }
    }

    .congratulations .image .span {
      font-size: 24px !important;
      top: 55% !important;
    }
  }
}

.showall {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  background: #5990FF;
  color: #fff;
  font-size: 2vw;
  padding: 5px 10px;
  border-radius: 20px;
}

.wordhidden {
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 2 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal !important;
  word-break: break-word;
  line-height: 1.3 !important;
  font-size: 1.6vw !important;
  max-width: 90% !important;
  margin: 0 auto;

  // 换行时居左显示
  &.wrap {
    text-align: left;
  }
}

.progress {
  height: 10%;
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  ::v-deep  .el-progress {
    width: 100%;
  }

  .text {
    text-align: right;
    font-size: 1.3vw;
    color: #5990FF;
    padding-left: 10px;
  }
}

.dialogMsg {
  .dio {
    background: #fff;
    border-radius: 22px;
    padding-top: 20px;

    img {
      display: block;
      margin: 30px auto;
      margin-bottom: 50px;
    }

    .title {
      text-align: center;
      font-size: 30px;
      line-height: 30px;
      margin-bottom: 20px;
    }

    .dioWord {
      text-align: center;
      font-size: 28px;
      line-height: 28px;
      padding-bottom: 30px;
    }
  }
}

.testPage {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: url('../../../assets/images/student/learnwords.png') no-repeat;
  background-size: 100% 100%;

  .main {
    background: url('../../../assets/images/student/unitBg.png') no-repeat;
    position: absolute;
    top: 52%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70%;
    height: 75%;

    background-size: 100% 100%;
    padding: 5vw;
    padding-bottom: 4vw;

    .unitsTitle {
      width: 50%;
      display: inline-block;
      position: absolute;
      top: -10%;
      left: 50%;
      transform: translateX(-50%);

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .text {
        position: absolute;
        top: 0;
        width: 100%;
        text-align: center;
        color: #000;
        font-size: 1.7vw;
        padding-top: 0.5vw;
      }
    }
  }

  .congratulations {
    width: 34vw;
    height: 25vw;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -60%);

    .image {
      position: relative;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .text {
        position: absolute;
        bottom: 20%;
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 1.2rem;
        left: -1.5vw;
      }

      .span {
        position: absolute;
        color: #fff;
        font-size: 5.5vw;
        top: 61%;
        left: 45%;
        transform: translate(-50%, -50%);
        -webkit-text-stroke: 0.25vw #FF4545;
        text-shadow: 5px 5px 5px #333;
      }
    }
  }

  .practice {
    width: 13rem;
    height: 4rem;
    position: fixed;
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, -10%);
    cursor: pointer;

    .left {
      width: 13rem;
      height: 4rem;
      position: relative;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        color: #fff;
        font-size: 1.3vw;
        transform: translate(-50%, -50%);
      }
    }

    .right {
      width: 13rem;
      height: 4rem;
      position: relative;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        color: #fff;
        font-size: 1.3vw;
        transform: translate(-50%, -50%);
      }
    }

    .text {
      position: absolute;
      top: 0;
      text-align: center;
      color: #fff;
      height: 100%;
      width: 100%;
      font-size: 28px;
      line-height: 4rem;
    }
  }

  // 松鼠
  .squirrel {
    position: absolute;
    top: 23%;
    left: 15%;
    width: 8vw;
    height: 6.57vw;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  //   第一次集训
  .test1 {
    width: 100%;
    height: 100%;

    .header {
      width: 100%;
      height: 15%;
      position: relative;

      .title {
        width: 50%;
        text-align: center;
        margin: auto;
        font-size: 1.9vw;
        color: #333;
      }

      .time {
        position: absolute;
        right: 2vw;
        top: .3vw;
        font-size: 1.7vw;

        span {
          color: #FF4545;
          font-size: 1.8vw;
        }
      }
    }

    .wordaudio {
      width: 100%;
      height: 15%;
      text-align: center;

      .word {
        color: #333;
        // 文字撑开div
        width: fit-content;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        font-size: 2vw;
        position: relative;
        margin: auto;
        max-width: 90%;
        display: block;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        .img {
          position: absolute;
          right: 0;
          width: 4vw;
          height: 4vw;
          top: -10px;
          right: -6vw;
          cursor: pointer;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .options {
      width: 100%;
      height: 65%;
      // border: 1px solid red;
      .option {
        position: relative;
        height: 20%;
        margin-bottom: 1%;

        .answer {
          box-sizing: border-box;
          cursor: pointer;
          padding: 1.5% 1.5vw;
          width: 50%;
          text-align: center;
          font-size: 1.5vw;
          margin: auto;
          border: 2px solid #FFFFFF;
          border-radius: 10px;
          color: #003333;
          line-height: 1.5vw;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &.long {
            font-size: 1.2vw;
          }

          &.xlong {
            font-size: 0.95vw;
          }

          .icon {
            width: 3vw;
            height: 3vw;
            position: absolute;
            top: 0;
            right: -5vw;

            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .test2 {
    width: 100%;
    height: 100%;

    .header {
      width: 100%;
      height: 15%;
      position: relative;

      .title {
        width: 50%;
        text-align: center;
        margin: auto;
        font-size: 1.9vw;
        color: #333;
      }

      .time {
        position: absolute;
        right: 2vw;
        top: .3vw;
        font-size: 1.7vw;

        span {
          color: #FF4545;
          font-size: 1.8vw;
        }
      }
    }

    .mean {
      width: 100%;
      height: 14%;
      text-align: center;
      font-size: 1.5vw;
      line-height: 1.3;
      color: #333;

      span {
        max-width: 100%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        cursor: pointer;

        // 换行时居左显示
        &.wrap {
          text-align: left;
        }
      }
    }

    .options2 {
      margin: auto;
      height: 16%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding-bottom: 0.4vw;

      .center {
        width: fit-content;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        position: relative;
        margin: auto;
      }

      .del {
        font-size: 2vw;
        position: absolute;
        right: -3vw;
        display: none;

        i {
          color: #666;
          cursor: pointer;
        }
      }

      .option2 {
        font-size: 2vw;
        float: left;
        padding: 0.5vw;
        background: #5990FF;
        color: #fff;
        border-radius: 6px;
        line-height: 2vw;
        margin-right: 5px;
      }
    }

    .hr {
      width: 40%;
      height: 2px;
      background: #000;
      margin: 0 auto;
    }

    .answers2 {
      padding-top: 15px;
      width: 50%;
      height: 49%;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: flex-start;
      gap: 10px;

      .answer2 {
        width: auto;
        min-width: 22%;
        height: 4vw;
        line-height: 4vw;
        padding: 0 0.6vw;
        font-size: 1.5vw;
        float: none;
        text-align: center;
        border: 2px solid #FFFFFF;
        border-radius: 6px;
        cursor: pointer;
        box-sizing: border-box;
        margin-bottom: 20px;
        margin-left: 0;
        white-space: nowrap;
      }

      .answer2.selected {
        background: #5990FF;
        border: 1px solid #5990FF;
        color: #fff;
      }
    }

    .btns {
      position: absolute;
      bottom: -1vw;
      width: 15%;
      left: 50%;
      height: 10%;
      transform: translateX(-50%);
      cursor: pointer;

      img {
        display: block;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

      span {
        position: absolute;
        top: 48%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1.6vw;
        color: #fff;
      }
    }
  }

  //   第一次集训
  .test4 {
    width: 100%;
    height: 100%;

    .header {
      width: 100%;
      height: 15%;
      position: relative;

      .title {
        width: 50%;
        text-align: center;
        margin: auto;
        font-size: 1.9vw;
        color: #333;
        max-width: 90%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }

      .time {
        position: absolute;
        right: 2vw;
        top: .3vw;
        font-size: 1.7vw;

        span {
          color: #FF4545;
          font-size: 1.8vw;
        }
      }
    }

    .wordaudio {
      width: 100%;
      height: 20%;
      text-align: center;

      .img {
        margin: auto;
        width: 4vw;
        height: 4vw;
        cursor: pointer;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }

    .options {
      width: 100%;
      height: 65%;

      .option {
        position: relative;
        height: 20%;
        margin-bottom: 1%;

        .answer {
          box-sizing: border-box;
          cursor: pointer;
          padding: 1.5% 1.5vw;
          width: 50%;
          text-align: center;
          font-size: 1.5vw;
          margin: auto;
          border: 2px solid #FFFFFF;
          border-radius: 10px;
          color: #003333;
          line-height: 1.5vw;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &.long {
            font-size: 1.2vw;
          }

          &.xlong {
            font-size: 0.95vw;
          }

          .icon {
            width: 3vw;
            height: 3vw;
            position: absolute;
            top: 0;
            right: -5vw;

            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  // test3/test4（请选择正确的单词）选项：字号统一不缩小，超长换行居左，不显示对错图标
  .test1:not(.cnAnswer),
  .test4 {
    .options {
      .option {
        height: auto;
        min-height: 20%;

        .answer {
          height: auto;
          white-space: normal;
          overflow: visible;
          text-overflow: clip;
          word-break: break-word;
          text-align: left;

          .icon {
            display: none;
          }
        }
      }
    }
  }

  // 平板端：选项纵向间距收窄，避免第四项贴近屏幕底端
  @media screen and (min-width: 701px) and (max-width: 1366px) {
    .test1:not(.cnAnswer),
    .test4 {
      .options .option {
        min-height: 0;
        margin-bottom: 1.5% !important;
      }
    }
  }
}
</style>
<style lang="scss">
.dialogMsg {
  .el-dialog {
    width: 400px;
    border-radius: 22px;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 18px 14px 18px;
    // background: #daffa5;
    background: #4cb2f1;
    border-radius: 22px;
  }
}

.testPage {
  .progress {
    .el-progress {
      width: 100%;
      margin: auto;
    }

    .el-progress-bar__inner {
      background: linear-gradient(251deg, #3862D9, #4EB7FB);
    }

    .el-progress-bar__outer {
      height: 16px !important;

      .el-progress-bar__innerText {
        display: none;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #87C2EF;
    border-radius: 20px;
  }
}
@media screen and (max-width: 768px) {
  .dialogMsg {
    .el-dialog {
      width: 85% !important;
      max-width: 320px !important;
    }

    .el-dialog__body {
      padding: 15px 12px !important;
    }

    .dio {
      img {
        width: 80px !important;
        margin: 20px auto !important;
      }

      .title {
        font-size: 20px !important;
        line-height: 20px !important;
      }

      .dioWord {
        font-size: 18px !important;
        line-height: 24px !important;
        padding-bottom: 20px !important;
      }
    }
  }

  .testPage {
    .progress {
      .el-progress {
        width: 90%;
        margin: auto;
        padding-right: 10px;
      }
      .el-progress-bar__outer {
        height: 12px !important;
      }
    }
  }
}
</style>
